import React from 'react';
import { IIconProps } from './utils';

export const Venn = ({
  fill = 'currentColor', height = 20, width = 20, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx={7.5}
      cy={10}
      r={5}
      stroke={fill}
      strokeWidth={1.66667}
    />
    <circle
      cx={12.5}
      cy={10}
      r={5}
      stroke={fill}
      strokeWidth={1.66667}
    />
  </svg>
);
